import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";

const urlCatalog = "Catalog";

export const newCiudad = async ({payload}) =>{
    return axios.post(`${APIURL}/${urlCatalog}/Ciudad/Add`, payload, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return Error.response.data;
    })
}

export const getCiudadAll = async ({codigo}) =>{
    return axios.get(`${APIURL}/${urlCatalog}/Ciudad/${codigo}`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}
//* Metodo para obtener catalogo de extras
export const getCatalogoExtras = async () =>{
    return axios.get(`${APIURL}/${urlCatalog}/Extras`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}
//* Metodo obtener catalogo tipo de pago
export const getCatalogoTiposPago = async () =>{
    return axios.get(`${APIURL}/${urlCatalog}/PaymentType`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}